import { UIHeading2, UIHeading3, useDeviceType } from '@cian/ui-kit';
import React, { FC } from 'react';

import * as styles from './DobroFormPart.css';

interface IDobroFormProps {
  title?: string;
  children: React.ReactNode;
}

export const DobroFormPart: FC<IDobroFormProps> = props => {
  const deviceType = useDeviceType();

  return (
    <div className={styles.block}>
      {props.title && (
        <div className={styles.header}>
          {deviceType === 'desktop' ? <UIHeading2>{props.title}</UIHeading2> : <UIHeading3>{props.title}</UIHeading3>}
        </div>
      )}
      {props.children}
    </div>
  );
};
